import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"
import type { ArealResponse } from "@fohet/caravan-booker-shared/types"
import { useAdminArealStore } from "@/store/adminArealStore"

export const useAdminAreal = () => {
    const selectedArealId = useAdminArealStore((s) => s.selectedArealId)

    return useQuery({
        queryKey: ["admin", "areals"],
        queryFn: () => api.get<ArealResponse[]>("/areals"),
        staleTime: 10 * 60 * 1000,
        select: (areals) => {
            const match = areals.find((a) => a.id === selectedArealId)
            return match ?? areals[0] ?? null
        },
    })
}
